import { useMemo } from 'react'

import { isServer } from 'src/libs/helper'
import { ProfileTranslator } from 'src/translators'
import { useProfileQuery } from 'src/types/generated'

import { useProfileStorage } from './useProfileStorage'

export const useGetProfile = () => {
  const { loading, data, error, refetch } = useProfileQuery()
  const { saveProfileToLocalStorage, removeProfileFromLocalStorage } = useProfileStorage()

  const profile = useMemo(
    () => (data && data.profile ? ProfileTranslator.toEntity(data.profile) : undefined),
    [data]
  )
  if (!isServer) {
    // GAで使用するためローカルストレージにも値を保存する
    profile ? saveProfileToLocalStorage(profile) : removeProfileFromLocalStorage()
  }

  return { loading, profile, error, refetch }
}
